/* eslint-disable @typescript-eslint/promise-function-async */
import { lazy, LazyExoticComponent } from 'react'
import { VehicleTypes } from 'dealer-types'
const CamperDataComponent = lazy(() => import('../components/molecules/offer/CamperDataComponent'))
// import MotorbikeDataComponent from '../components/molecules/offer/MotorbikeDataComponent'
const MotorbikeDataComponent = lazy(() => import('../components/molecules/offer/MotorbikeDataComponent'))
const AgriculturalDataComponent = lazy(() => import('../components/molecules/offer/AgriculturalDataComponent'))
const JetSkiDataComponent = lazy(() => import('../components/molecules/offer/JetSkiDataComponent'))

const getVehicleComponent = (
  vehicleType: VehicleTypes,
  vehicleLoaded: boolean
): LazyExoticComponent<() => JSX.Element> | (() => null) => {
  if (!vehicleLoaded) {
    return () => null
  }
  if (vehicleType === 'Camper') {
    return CamperDataComponent
  }
  if (vehicleType === 'AgriculturalMachine') {
    return AgriculturalDataComponent
  }
  if (vehicleType === 'JetSki') {
    return JetSkiDataComponent
  }
  return MotorbikeDataComponent
}

export default getVehicleComponent
